import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "wouter";
import { Alert, AlertActions, AlertDescription, AlertTitle, } from "catalyst/alert";
import { Button } from "catalyst/button";
export const loginRedirectErrorMessage = (error) => {
    switch (error) {
        case "already_logged_in":
            return "Пожалуйста, выйдите из аккаунта перед входом в другой.";
        case "login_key_not_found":
            return "Ссылка для входа недействительна.";
        case "internal_error":
            return "Во время входа произошла ошибка. Попробуйте еще раз чуть позже.";
        default:
            return null;
    }
};
export const LoginRedirectErrorAlert = ({ error, }) => {
    const [, navigate] = useLocation();
    const [searchParams] = useSearchParams();
    const message = loginRedirectErrorMessage(error);
    const [open, setOpen] = useState(message !== null);
    useEffect(() => {
        setOpen(message !== null);
    }, [message]);
    if (!message) {
        return null;
    }
    const close = () => {
        const nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.delete("error");
        const nextQuery = nextSearchParams.toString();
        navigate(nextQuery
            ? `${window.location.pathname}?${nextQuery}`
            : window.location.pathname, { replace: true });
        setOpen(false);
    };
    return (_jsxs(Alert, { open: open, onClose: (isOpen) => {
            if (!isOpen) {
                close();
            }
        }, children: [_jsx(AlertTitle, { children: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0432\u0445\u043E\u0434" }), _jsx(AlertDescription, { children: message }), _jsx(AlertActions, { children: _jsx(Button, { onClick: close, children: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E" }) })] }));
};
